import Axios, {
  AxiosRequestHeaders,
  AxiosResponse, AxiosResponseHeaders
} from 'axios';

import { CodeEnum } from '@interface/public';
import {
  RequestRefresh, ResponseRefresh, AxiosRefresh,
  RequestCheckPhone, ResponseCheckPhone, AxiosCheckPhone
} from '@server/apiSSO';
import { e } from 'node_modules/mathjs/types';

export default class RQ {
  public static readonly SSO = { // 单点登录
    /**
     * 检测
     * @return {boolean} 返回是否已登录
     */
    check(): boolean {
      // return $Store.User().token !== '' && $Store.User().userID !== '' && $Store.User().username !== '';
      return $Store.User().token !== '' && $Store.User().userID !== '';
    },
    
    /**
     * 登录
     * @param {string} href 登录后的回调地址
     * @param {string} operate 操作
     */
    login(href: string = location.href, operate: string = ''): void {
      let data: any = {
        [$Enum.ParamEnum.Source]: encodeURIComponent(href),
        [$Enum.ParamEnum.Operate]: operate
      };
      
      $Store.User().sourceAccess && (data[$Enum.ParamEnum.SourceAccess] = $Store.User().sourceAccess);
      location.href = $FN.Url.set(data, `${ $Config.Href.sso }/sso/${ $Enum.SSOEnum.Index }`);
    },
    
    /**
     * 退出登录
     */
    logout(): void {
      $Store.User().clearInfo();
    }
  };
  
  /**
   * 请求静态文件
   * @param {string} url
   */
  public static GetFile(url: string): Promise<any> {
    return Axios.get(url, {
      timeout: 10000,
      transformRequest: [
        (data: any, header: AxiosRequestHeaders): string => {
          // console.log('/////请求文件', url);
          return data;
        }
      ],
      transformResponse: [
        (data: string, header: AxiosResponseHeaders): string => {
          // console.log('/////接收文件', data);
          return data;
        }
      ]
    });
  }
  
  /**
   * 请求刷新会话
   * @param {Function} callback 回调
   */
  public static RefreshToken(callback: Function = null): void {
    AxiosRefresh({} as RequestRefresh)
      .then((response: any) => {
        const data: ResponseRefresh = response.data;
        
        if (data.code !== CodeEnum.Normal) return;
        
        $Store.User().updateInfo({
          token: data.data.token
        });
        
        callback && callback();
      });
  }
  
  /**
   * 校验手机号
   * @param {string} phone 手机号
   * @return {boolean} 是否已注册
   */
  public static async CheckPhone(phone: string): Promise<boolean> {
    let result = false;
    
    await AxiosCheckPhone({
      phone
    } as RequestCheckPhone)
      .then((response: any) => {
        const data: ResponseCheckPhone = response.data;
        
        if (data.code !== $Enum.CodeEnum.Normal) return;
        
        result = data.data.is_registered === 1;
      });
    
    return result;
  }
  public static async WeChatAuthorized(): Promise<any> {
  // const targetUrl = ['32rc.apps.galaxy-future.com','36rc.apps.galaxy-future.com'];
  const targetUrl:any = [];
  const isTargetSource =$FN.Agent.client() !== 'PC' && $Store.User().source && targetUrl.some((url:any) => decodeURIComponent($Store.User().source).includes(url));
  const isRNApp =
    isTargetSource &&
    (window?.GFConfig?.type === 'Android' ||
    window?.GFConfig?.type === 'iOS');

  // ✅ RN 环境：交给原生
  if (isRNApp) {
    //@ts-ignore
    window?.GFPostMessage?.('wechat_login_request', {});
    return;
  }

  // ✅ 只有微信内置浏览器才走 oauth2
  const isWX = $FN.Agent.browser() === 'WeChat',
    href = isWX
    ? 'https://open.weixin.qq.com/connect/oauth2/authorize'
    : 'https://open.weixin.qq.com/connect/qrconnect';

  const redirectUrl = $ENV.isProduction
      ? $Config.Href.sso + $Enum.RouterEnum.ChannelWeChat
      : $Config.Href.sso + '/#' + $Enum.RouterEnum.ChannelWeChat,
    data: any = {
      appid: isWX
        ? $Config.ID.weChatServer
        : $Config.ID.weChatWebApp,
      redirect_uri: encodeURIComponent(
        $FN.Url.set(
          {
            [$Enum.ParamEnum.Operate]: $Store.User().operate,
            [$Enum.ParamEnum.Source]: $Store.User().source,
            [$Enum.ParamEnum.Invite]: $Store.User().invite
          },
          redirectUrl
        )
      ),
      response_type: 'code',
      scope: isWX ? 'snsapi_userinfo' : 'snsapi_login',
      state: 'gf_wechat'
    };
  // $RQ.PushWebHookFeiShu(
  //       $Store.User().username,
  //       `WeChatAuthorized: ${ href + '?' +
  //   Object.keys(data).map(k => `${k}=${data[k]}`).join('&') +
  //   (isWX ? '#wechat_redirect' : '')},data: ${JSON.stringify(data)}`
  //     );
  location.href =
    href + '?' +
    Object.keys(data).map(k => `${k}=${data[k]}`).join('&') +
    (isWX ? '#wechat_redirect' : '');
}

  
  /**
   * 普罗米修斯WebHook
   * @param {*} data 数据
   */
  public static async PushWebHookPrometheus(data: any): Promise<any> {
    if (!$ENV.isFormal) return;
    
    $FN.Retry(async () => {
        await Axios.post('https://api.galaxy-future.com/utcollector/api/v1/event_tracking', {
            psm: 'gcom.fe.sso', // 系统
            device: $FN.Agent.client(), // 客户端
            path: location.href, // 地址
            pid: '', // 页面标识
            t: $Moment().unix(), // 时间戳
            action: '', // 行动
            uid: $Store.User().userID, // 用户标识
            latency: 0, // 耗时
            ...data,
            bdata: data.bdata ? JSON.stringify(data.bdata) : '' // 拓展字段（JSON字符串）
          })
          .then((response: AxiosResponse) => {
            if (response.status !== 200) throw new Error();
            console.log(`${ $Config.Console.log }WebHook-普罗米修斯：${ data.action }`);
          });
      })
      .catch((e: any) => {
        console.log(`${ $Config.Console.log }WebHook-普罗米修斯：发送失败`);
      });
  }
  
  /**
   * 飞书WebHook
   * @param {string} user 用户（名称|手机号）
   * @param {string} content 事件
   */
  public static async PushWebHookFeiShu(user: string, content: string): Promise<any> {
    if (!$ENV.isFormal) return;
    
    try {
      content = decodeURIComponent(content);
    }
    catch (e: any) {}
    
    $FN.Retry(async () => {
        await Axios.post(`https://open.feishu.cn/open-apis/bot/v2/hook/${ $Config.ID.feiShu }`, {
            msg_type: 'post',
            content: {
              post: {
                zh_cn: {
                  title: 'SSO消息通知',
                  content: [
                    [
                      {
                        tag: 'text',
                        text: `用户：${ user }`
                      }
                    ],
                    [
                      {
                        tag: 'text',
                        text: `触发操作：${ content }`
                      }
                    ]
                  ]
                }
              }
            }
          })
          .then((response: AxiosResponse) => {
            if (response.status !== 200) throw new Error();
            console.log(`${ $Config.Console.log }WebHook-飞书：${ content }`);
          });
      })
      .catch((e: any) => {
        console.log(`${ $Config.Console.log }WebHook-飞书：发送失败`);
      });
  }
  
  /**
   * 百度推广WebHook
   * @param {string} id 百度标识
   */
  public static async PushWebHookBaiduPromotion(id: string) {
    if (!$ENV.isFormal) return;
    if (!$Store.User().bdVid) return;
    
    $FN.Retry(async () => {
        await Axios.post(`${ $ENV.isFormal ? 'https://api.galaxy-future.com' : 'http://172.16.16.181' }/website/convertdata/upload`, {
            channel: '10001',
            data: JSON.stringify({
              conversionTypes: [
                {
                  logidUrl: decodeURIComponent(id),
                  newType: 25
                }
              ]
            })
          })
          .then((response: AxiosResponse) => {
            if (response.status !== 200) throw new Error();
            console.log(`${ $Config.Console.log }WebHook-百度推广：${ id }`);
          });
      })
      .catch((e: any) => {
        console.log(`${ $Config.Console.log }WebHook-百度推广：发送失败`);
      });
  }
}